import { createBrowserRouter, redirect } from 'react-router';
import HomeLayout from '@/app/components/HomeLayout';
import ProjectLayout from '@/app/components/ProjectLayout';
import ProjectsView from '@/app/components/ProjectsView';
import CitiesView from '@/app/components/CitiesView';
import TemplateSetsView from '@/app/components/TemplateSetsView';
import TemplateSetEditor from '@/app/components/TemplateSetEditor';
import GenerationView from '@/app/components/GenerationView';
import GenerationPreviewView from '@/app/components/GenerationPreviewView';
import GenerationLogsView from '@/app/components/GenerationLogsView';
import QuickGenerateView from '@/app/components/QuickGenerateView';
import NotFound from '@/app/components/NotFound';
import LoginView from '@/app/components/LoginView';
import { requireAuth } from '@/lib/auth';

export const router = createBrowserRouter([
  {
    path: '/login',
    Component: LoginView,
  },
  {
    path: '/',
    loader: requireAuth,
    Component: HomeLayout,
    children: [
      { index: true, Component: ProjectsView },
    ],
  },
  {
    path: '/projects/:projectId',
    loader: requireAuth,
    Component: ProjectLayout,
    children: [
      {
        index: true,
        loader: ({ params }) => redirect(`/projects/${params.projectId}/templates`),
      },
      { path: 'variables', loader: ({ params }) => redirect(`/projects/${params.projectId}/templates`) },
      { path: 'data', Component: CitiesView },
      { path: 'templates', Component: TemplateSetsView },
      { path: 'templates/:templateSetId', Component: TemplateSetEditor },
      { path: 'generate', Component: GenerationView },
      { path: 'generate/preview', Component: GenerationPreviewView },
      { path: 'quick-generate', Component: QuickGenerateView },
      { path: 'logs', Component: GenerationLogsView },
    ],
  },
  { path: '*', Component: NotFound },
]);
